import React from "react";
import arrowIcon from "../assets/images/link-arrow.svg";
import { PersonContact } from "../models/person/Person";
import { FileLink } from "../models/shared/FileLink";
import { rewriteDisclaimerFileUrl } from "../utilities/routes/disclaimerFileUtilities";
import { ContactPerson } from "./ContactPerson";
import PortableText, { PortableTextBody } from "./PortableText";

export interface DisclaimerBannerProps {
  title?: string;
  portableTextContent?: PortableTextBody;
  _rawPortableTextContent?: PortableTextBody;
  secondaryTitle?: string;
  files?: FileLink[];
  contactsTitle?: string;
  contacts?: PersonContact[];
}

export const DisclaimerBanner = (props: DisclaimerBannerProps) => (
  <aside className="max-w-none px-0 bg-brand-primary-40 py-12 lg:py-16 xl:py-40 text-neutral-100">
    <div className="max-w-screen-xl w-full mx-auto px-4 md:px-6 flex flex-wrap justify-center items-start">
      <div className="flex flex-col flex-none w-full mb-8 lg:w-1/2 lg:pr-12 lg:mb-0">
        <h2 className="text-current">{props.title}</h2>
        {(props._rawPortableTextContent || props.portableTextContent) && (
          <PortableText
            _rawBody={props._rawPortableTextContent ?? props.portableTextContent}
            addSections={false}
            elementClasses={{
              h1: "text-current",
              h2: "text-current",
              h3: "text-current",
              p: "text-current",
              li: "text-current"
            }}
          />
        )}
      </div>
      <div className="flex flex-col flex-none w-full lg:w-1/2 lg:pl-12">
        <h2 className="text-current">{props.secondaryTitle}</h2>
        <ul className="flex flex-col items-start mb-4">
          {!!props.files?.length &&
            props.files.map((fileLink, index) => (
              <li key={index}>
                <a
                  href={rewriteDisclaimerFileUrl(fileLink.file) ?? ""}
                  className="group flex flex-none items-center text-brand-secondary-70 font-bold no-underline border-b border-brand-secondary-70"
                >
                  {fileLink.title}{" "}
                  <svg
                    width={16}
                    height={16}
                    className="ml-2 fill-current card-arrow group-hover:translate-x-1"
                  >
                    <use xlinkHref={arrowIcon.url} />
                  </svg>
                </a>
              </li>
            ))}
        </ul>
        <hr className="border-neutral-100 opacity-1 mb-12" />
        <h3 className="text-current">{props.contactsTitle}</h3>
        <ul className={"flex flex-col pt-5"}>
          {props.contacts?.map((contact, index) => (
            <ContactPerson key={index} {...contact} textColor="light" />
          ))}
        </ul>
      </div>
    </div>
  </aside>
);
